import moment from "moment";
import React from "react";
import Chart from "react-apexcharts";

export function LeadsChart({ data, visualizationType }) {
  if (!data) return null;

  const formattedData = Object.values(data);

  const series = [
    {
      name: "Leads",
      data: formattedData.map((item) => item.opportunities),
      color: "#722ed1",
      type: "area",
    },
    {
      name: "Clientes positivos",
      data: formattedData.map((item) => item.positives),
      color: "#52c41a",
      type: "area",
    },
    {
      name: "Clientes negativos",
      data: formattedData.map((item) => item.negatives),
      color: "#ff4d4f",
      type: "area",
    },
  ];

  if (visualizationType === "custom_months") {
    series[3] = {
      name: "Acessos",
      data: formattedData.map((item) => item.access),
      color: "#40a9ff",
      type: "column",
    };
  }

  return (
    <Chart
      height={350}
      series={series}
      options={{
        chart: {
          type: "area",
          stacked: false,
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
          dropShadow: {
            enabled: true,
            color: '#000',
            top: 10,
            left: 7,
            blur: 10,
            opacity: 0.1
          }
        },
        colors: ['#722ed1', '#52c41a', '#ff4d4f'],
        dataLabels: {
          enabled: true,
          enabledOnSeries: undefined,
          formatter: function(val, opts) {
            return val === 0 ? '' : val;
          },
          textAnchor: 'middle',
          distributed: false,
          offsetX: 0,
          offsetY: -5,
          style: {
            fontSize: '11px',
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontWeight: 'bold',
            colors: ['#722ed1', '#52c41a', '#ff4d4f']
          },
          background: {
            enabled: true,
            foreColor: '#fff',
            padding: 3,
            borderRadius: 3,
            borderWidth: 1,
            borderColor: '#fff',
            opacity: 0.9,
          },
          dropShadow: {
            enabled: true,
            top: 1,
            left: 1,
            blur: 1,
            color: '#000',
            opacity: 0.3
          }
        },
        stroke: {
          width: [3, 3, 3],
          curve: 'smooth'
        },
        fill: {
          type: ['gradient', 'gradient', 'gradient'],
          gradient: {
            shadeIntensity: 1,
            type: 'vertical',
            opacityFrom: [0.6, 0.5, 0.4],
            opacityTo: [0.1, 0.1, 0.1],
            stops: [0, 100],
            colorStops: []
          }
        },
        xaxis: {
          categories: Object.keys(data).map((item) => {
            if (visualizationType === "current_month") {
              return moment(item).format("DD/MM");
            } else {
              return moment(`${item}-01`).format("MMM/YY");
            }
          }),
          axisBorder: {
            show: true,
            color: '#e8e8e8'
          },
          axisTicks: {
            show: true,
            color: '#e8e8e8'
          },
          labels: {
            style: {
              colors: '#666',
              fontSize: '12px'
            }
          }
        },
        grid: {
          show: true,
          borderColor: '#f0f0f0',
          strokeDashArray: 3,
          position: 'back',
          xaxis: {
            lines: {
              show: false
            }
          },
          yaxis: {
            lines: {
              show: true
            }
          },
          padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
          }
        },
        yaxis: {
          show: true,
          decimalsInFloat: 0,
          min: 0,
          forceNiceScale: true,
          tickAmount: 6,
          labels: {
            formatter: function(value) {
              return Math.round(value);
            },
            style: {
              colors: '#666',
              fontSize: '12px'
            }
          }
        },
        legend: {
          show: true,
          position: 'bottom',
          horizontalAlign: 'center',
          floating: false,
          fontSize: '13px',
          fontFamily: 'Helvetica, Arial',
          fontWeight: 400,
          formatter: undefined,
          inverseOrder: false,
          width: undefined,
          height: undefined,
          tooltipHoverFormatter: undefined,
          customLegendItems: [],
          offsetX: 0,
          offsetY: 8,
          labels: {
            colors: ['#722ed1', '#52c41a', '#ff4d4f'],
            useSeriesColors: false
          },
          markers: {
            width: 12,
            height: 12,
            strokeWidth: 0,
            strokeColor: '#fff',
            fillColors: undefined,
            radius: 12,
            customHTML: undefined,
            onClick: undefined,
            offsetX: 0,
            offsetY: 0
          },
          itemMargin: {
            horizontal: 12,
            vertical: 5
          }
        },
        tooltip: {
          enabled: true,
          shared: true,
          intersect: false,
          theme: 'light',
          style: {
            fontSize: '12px'
          },
          x: {
            show: true,
            format: 'dd/MM/yyyy',
            formatter: undefined
          },
          y: {
            formatter: function(value, { series, seriesIndex, dataPointIndex, w }) {
              if (!Number.isInteger(value) || value === null || value === undefined) return 0;
              return value;
            },
            title: {
              formatter: function(seriesName) {
                return seriesName + ': ';
              }
            }
          },
          marker: {
            show: true
          },
          items: {
            display: 'flex'
          },
          fixed: {
            enabled: false,
            position: 'topRight',
            offsetX: 0,
            offsetY: 0
          }
        },
      }}
    />
  );
}
